import React from "react";
import { Container, Row, Col } from "reactstrap";
import InputSelect from "../../components/InputSelect";
import SelectFilterClear from "../../components/SelectFilterClear";
import TableStudents from "./TableStudents";

export default function Students() {
  return (
    <Container fluid>
      <Row>
        <Col xs={12} sm={12} md={9} lg={9} xl={10}>
          <InputSelect />
        </Col>

        <Col xs={12} sm={12} md={3} lg={3} xl={2}>
          <button className="button-new-student-by-nile">
            {" "}
            <span style={{ color: "#134e96" }}>New</span> student
          </button>
        </Col>

        <Col xs={12} sm={12} md={6} lg={3} xl={3}>
          <SelectFilterClear headerSelectFilterClear="Class" />
        </Col>

        <Col xs={12} sm={12} md={6} lg={3} xl={3}>
          <SelectFilterClear headerSelectFilterClear="Room" />
        </Col>
      </Row>

      <Row>
        <Col>
          <TableStudents />
        </Col>
      </Row>
      <br />
    </Container>
  );
}
